import { useSeti } from '../utils/useSeti';
export const getFeatureConfig = viewType => {
  const featureConfig = {
    LANDING: {
      isCaresSurveyEligible: false,
      isSurveyEligible: true,
      setiValues: {
        enableMyTripsSignIn: true,
        enableVoice: true,
        enableVoiceTooltip: true,
        isRealtime: true,
        shouldDisplayCheckoutButton: true,
        shouldDisplaySurvey: Boolean(useSeti({
          testName: 'PENNY_SURVEY_CHAT_HISTORY',
          shouldFireImpression: false
        })),
        shouldEnableSelectTrip: Boolean(useSeti({
          testName: 'CHATBOT_TRIP_CARDS_SELECT_TRIP',
          shouldFireImpression: false
        })),
        shouldDisplayGenHotelFeature: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    PORTAL: {
      isCaresSurveyEligible: false,
      isSurveyEligible: true,
      setiValues: {
        enableMyTripsSignIn: true,
        enableVoice: true,
        enableVoiceTooltip: true,
        isRealtime: true,
        shouldDisplayCheckoutButton: true,
        shouldDisplaySurvey: Boolean(useSeti({
          testName: 'PENNY_SURVEY_CHAT_HISTORY',
          shouldFireImpression: false
        })),
        shouldEnableSelectTrip: Boolean(useSeti({
          testName: 'CHATBOT_TRIP_CARDS_SELECT_TRIP',
          shouldFireImpression: false
        })),
        shouldDisplayGenHotelFeature: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    STAYDETAILS: {
      isCaresSurveyEligible: false,
      isSurveyEligible: false,
      setiValues: {
        enableMyTripsSignIn: true,
        isRealtime: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    STAYLISTINGS: {
      isCaresSurveyEligible: false,
      isSurveyEligible: false,
      setiValues: {
        enableMyTripsSignIn: true,
        isRealtime: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    ITINERARY: {
      isCaresSurveyEligible: true,
      isSurveyEligible: true,
      setiValues: {
        enableVoice: true,
        enableVoiceTooltip: true,
        isCaresSurveyEnabled: true,
        enableMyTripsSignIn: true,
        isRealtime: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    FLY: {
      isCaresSurveyEligible: false,
      isSurveyEligible: false,
      setiValues: {
        isRealtime: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    DRIVE: {
      isCaresSurveyEligible: false,
      isSurveyEligible: false,
      setiValues: {
        isRealtime: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    PACKAGE: {
      isCaresSurveyEligible: false,
      isSurveyEligible: false,
      setiValues: {
        isRealtime: true
      },
      quickActionsStackVariant: 'HORIZONTAL'
    },
    CHECKOUT: {
      isCaresSurveyEligible: false,
      isSurveyEligible: false,
      setiValues: {
        isRealtime: false
      },
      quickActionsStackVariant: 'HORIZONTAL'
    }
  };
  // Ensure viewType has a valid feature config
  const config = featureConfig[viewType];
  if (!config) {
    throw new Error(`No feature configuration found for viewType: ${viewType}. ` + 'Add configuration to featureConfig object in /react-components/penny-chat-bot/src/config/featureConfig.ts. ');
  }
  return config;
};